/** Роли, които виждат само Driver Portal (без странично меню и други модули). */
export const DRIVER_PORTAL_ONLY_ROLES = [
  'user',
  'driver',
  'driver_novice',
  'driver_pro',
];

/** Normalize role from API (string or `{ name }` object). */
export function resolveRoleName(role) {
  if (!role) return '';
  if (typeof role === 'object' && role.name) return String(role.name);
  return String(role);
}

export function isDriverPortalOnlyRole(role) {
  return DRIVER_PORTAL_ONLY_ROLES.includes(resolveRoleName(role));
}
